import { SchemaRecord } from "../SchemaRecord.js";

export class PeerLinksListParams extends SchemaRecord {
  static type = "chat.params.peer_links_list";
  static schema = {};
}
